import API from './api';

export const addAdvanceLog = async (recipientMobileNumber, amount, date, notes) => {
  try {
    const advanceData = { recipientMobileNumber, amount, date, notes };
    const response = await API.post('/advances', advanceData);
    return response.data;
  } catch (error) {
    console.error('Error adding advance:', error);
    throw error;
  }
};

export const getAdvanceLogForUser = async (mobileNumber) => {
  try {
    const response = await API.get(`/advances/log/${mobileNumber}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching advance log for ${mobileNumber}:`, error);
    throw error;
  }
};

export const getPendingAdvance = async (mobileNumber) => {
  try {
    const response = await API.get(`/advances/pending/${mobileNumber}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching pending advance for ${mobileNumber}:`, error);
    throw error;
  }
};

export const getAdvanceHistoryForMonth = async (mobileNumber, year, month) => {
  try {
    const response = await API.get(`/advances/history/${mobileNumber}/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching advance history for ${mobileNumber}:`, error);
    throw error;
  }
};

export const getMonthlyAdvanceDetails = async (mobileNumber, year, month) => {
  try {
    const response = await API.get(`/advances/details/${mobileNumber}/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching monthly advance details for ${mobileNumber}:`, error);
    throw error;
  }
};

// Get advance details for all users for a specific month (bulk API)
export const getAllUsersMonthlyAdvanceDetails = async (year, month) => {
  try {
    const response = await API.get(`/advances/all-users/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching monthly advance details for all users for ${year}-${month}:`, error);
    throw error;
  }
};

export const getAdvanceLog = async (mobileNumber) => {
  try {
    const response = await API.get(`/advances/${mobileNumber}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching advance log for ${mobileNumber}:`, error);
    throw error;
  }
};

export const updateAdvanceLog = async (recipientMobileNumber, timestamp, amount, notes) => {
  try {
    const response = await API.put(`/advances/${recipientMobileNumber}/${timestamp}`, { amount, notes });
    return response.data;
  } catch (error) {
    console.error(`Error updating advance log for ${recipientMobileNumber}:`, error);
    throw error;
  }
};

export const deleteAdvanceLog = async (recipientMobileNumber, timestamp) => {
  try {
    const response = await API.delete(`/advances/${recipientMobileNumber}/${timestamp}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting advance log for ${recipientMobileNumber}:`, error);
    throw error;
  }
};

// Get advance summary for all users
export const getAllUsersAdvanceSummary = async () => {
  try {
    const response = await API.get('/advances/summary');
    return response.data;
  } catch (error) {
    console.error('Error fetching all users advance summary:', error);
    throw error;
  }
}; 